module.exports = __webpack_public_path__ + "img/profit-right-comtent-img.13f0d0fa.png";